import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';


function Sidebar2({ permissions }) {

    const [selected, setSelected] = useState('');
    const sidebarRef = useRef(null); // We create a reference for the sidebar


    const hasAccess = (objId) => {
        return permissions.some(obj => obj.obj_ID === objId);
    };

    const handleSelect = (item) => {
        setSelected(item);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (window.innerWidth <= 768) {
                if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                    const htmlElement = document.querySelector('html');
                    const body = document.querySelector('body');
                    htmlElement.setAttribute('data-sidebar-size', 'sm');
                    body.setAttribute('class', 'twocolumn-panel');
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [sidebarRef]);


    return (
        <div className="app-menu navbar-menu" style={{ background: "#131715" }} ref={sidebarRef}>
            <div className="navbar-brand-box">

                <Link to="/main-panel" className="logo logo-light">
                    <span className="logo-sm">
                        <img src="assets/images/dbclondon-sm.jpg" alt="" height="40" style={{ borderRadius: "20px" }} />
                    </span>
                    <span className="logo-lg align-items-center mt-4">
                        <img
                            src="assets/images/dbclondon-sm.png"
                            alt="Logo"
                            style={{ borderRadius: "100px", width: "70px", height: "70px" }}
                        />
                        <Link
                            className="text-white display-6 mb-0 mt-4"
                            style={{
                                textShadow: "0 0 10px rgba(255, 255, 255, 0.6)", // Brightness effect
                                left: "4px",
                                fontSize: "15px",
                                top: "5px",
                            }}
                        >
                            ADMIN PANEL
                        </Link>
                    </span>
                </Link>
                <button
                    type="button"
                    className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
                    id="vertical-hover"
                >
                    <i className="ri-record-circle-line"></i>
                </button>
            </div>
            <div id="scrollbar" data-id="scrollbar">
                <div className='container-fluid'>
                    <ul className="navbar-nav" id="navbar-nav">
                        <li className="menu-title">
                            <span data-key="t-menu">Menu</span>
                        </li>

                        <li >
                            <Link
                                className={`nav-link menu-link ${selected === 'main-panel' ? 'selected' : ''}`}
                                to="/main-panel"
                                role="button"
                                aria-expanded="false"
                                aria-controls="main-panel"
                                onClick={() => handleSelect('main-panel')}
                            >
                                <i class="ri-home-2-line"></i><span>Main</span>
                            </Link>
                        </li>

                        <li >
                            <a
                                className={`nav-link menu-link ${selected === 'SALES' ? 'selected' : ''}`}
                                href="#SALES"
                                data-bs-toggle="collapse"
                                role="button"
                                aria-expanded="false"
                                aria-controls="SALES"
                                onClick={() => handleSelect('SALES')}
                            >
                                <i className="ri-file-list-3-line"></i><span data-key="t-dashboards">Pre Production</span>
                            </a>
                            <div className="collapse menu-dropdown" id="SALES">
                                <ul className="nav nav-sm flex-column">

                                    <li >
                                        <Link to="/quotation" className="nav-link">Instant Quotes</Link>
                                    </li>

                                    <li >
                                        <Link to="/orders" className="nav-link">Orders</Link>
                                    </li>

                                    <li >
                                        <Link to="/bussiness-library" className="nav-link">STL Adjustment Folder</Link>
                                    </li>
                                    <li>
                                        <Link to="/mould-folders" className="nav-link">Mould Library</Link>
                                    </li>

                                     <li>
                                        <Link to="/mould-auth" className="nav-link">Customer Mould Manager</Link>
                                    </li>

                                    <li >
                                        <Link to="/jobs-print-folder" className="nav-link" data-key="t-ecommerce">Print Folder</Link>
                                    </li>

                                      <li>
                                        <Link to="/wax-folder" className="nav-link" data-key="t-ecommerce">Wax Folder</Link>
                                    </li>

                                </ul>
                            </div>
                        </li>

                        <li >
                            <a
                                className={`nav-link menu-link ${selected === 'Jobs' ? 'selected' : ''}`}
                                href="#Jobs"
                                data-bs-toggle="collapse"
                                role="button"
                                aria-expanded="false"
                                aria-controls="Jobs"
                                onClick={() => handleSelect('Jobs')}
                            >
                                <i class="ri-folder-settings-fill"></i><span data-key="t-dashboards">Production</span>
                            </a>
                            <div className="collapse menu-dropdown" id="Jobs">
                                <ul className="nav nav-sm flex-column">

                                    <li >
                                        <Link to="/job-live-feed" className="nav-link">Live Feed</Link>
                                    </li>

                                    <li >
                                        <Link to="/scan-point" className="nav-link" data-key="t-ecommerce">Scan Point</Link>
                                    </li>

                                    <li >
                                        <Link to="/jobs-reprint-folder" className="nav-link">Reprint Folder</Link>
                                    </li>

                                    <li >
                                        <Link to="/collective-jobs" className="nav-link">Collective Page</Link>
                                    </li>

                                    {/*      <li >
                                        <Link to="/jobs" className="nav-link" data-key="t-ecommerce">Jobs</Link>
                                    </li> */}
                                </ul>
                            </div>
                        </li>

                        <li >
                            <a
                                className={`nav-link menu-link ${selected === 'Jobs1' ? 'selected' : ''}`}
                                href="#Jobs1"
                                data-bs-toggle="collapse"
                                role="button"
                                aria-expanded="false"
                                aria-controls="Jobs1"
                                onClick={() => handleSelect('Jobs1')}
                            >
                                <i class="ri-list-check-2"></i><span data-key="t-dashboards">Post Production</span>
                            </a>
                            <div className="collapse menu-dropdown" id="Jobs1">
                                <ul className="nav nav-sm flex-column">

                                    <li >
                                        <Link to="/invoice-list" className="nav-link" data-key="t-ecommerce">Invoices</Link>
                                    </li>


                                    {/*      <li >
                                        <Link to="/jobs" className="nav-link" data-key="t-ecommerce">Jobs</Link>
                                    </li> */}
                                </ul>
                            </div>
                        </li>

                        <li >
                            <a
                                className={`nav-link menu-link ${selected === 'Customers' ? 'selected' : ''}`}
                                href="#Customers"
                                data-bs-toggle="collapse"
                                role="button"
                                aria-expanded="false"
                                aria-controls="Customers"
                                onClick={() => handleSelect('dashboard5')}
                            >
                                <i class="ri-group-line"></i> <span data-key="t-dashboards">Customers</span>
                            </a>
                            <div className="collapse menu-dropdown" id="Customers">
                                <ul className="nav nav-sm flex-column">

                                    <li >
                                        <Link to="/customers" className="nav-link" data-key="t-analytics">Customers</Link>
                                    </li>

                                </ul>
                            </div>
                        </li>

                        <li >
                            <a
                                className={`nav-link menu-link ${selected === 'Adminitration' ? 'selected' : ''}`}
                                href="#Adminitration"
                                data-bs-toggle="collapse"
                                role="button"
                                aria-expanded="false"
                                aria-controls="sidebarDashboards3"
                                onClick={() => handleSelect('Adminitration')}
                            >
                                <i className="las la-pencil-ruler"></i> <span data-key="t-dashboards">Administration</span>
                            </a>
                            <div className="collapse menu-dropdown" id="Adminitration">
                                <ul className="nav nav-sm flex-column">
                                    <li >
                                        <Link to="/quotations-history" className="nav-link" data-key="t-analytics">Quotations History</Link>
                                    </li>
                                    <li >
                                        <Link to="/order-history" className="nav-link" data-key="t-analytics">Order History</Link>
                                    </li>
                                    <li>
                                        <Link to="/job-history" className="nav-link" data-key="t-analytics">Jobs History</Link>
                                    </li>

                                     <li>
                                        <Link to="/wax-history" className="nav-link" data-key="t-analytics">Wax History</Link>
                                    </li>

                                    <li >
                                        <Link to="/collective-groups" className="nav-link" data-key="t-crypto">Collective Groups</Link>
                                    </li>
                                    <li >
                                        <Link to="/branchs" className="nav-link" data-key="t-analytics">Branchs</Link>
                                    </li>
                                    <li >
                                        <Link to="/product-list" className="nav-link" data-key="t-crm">Products</Link>
                                    </li>

                                    {/*   <li >
                                        <Link to="/offers-list" className="nav-link" data-key="t-ecommerce">Offers</Link>
                                    </li>
 */}

                                    <li >
                                        <Link to="materials" className="nav-link" data-key="t-crypto">Materials</Link>
                                    </li>
                                    <li >
                                        <Link to="/metal-types" className="nav-link" data-key="t-crypto">Material type</Link>
                                    </li>
                                    <li >
                                        <Link to="/option-job-category" className="nav-link" data-key="t-crypto">Option Job Category</Link>
                                    </li>
                                    <li >
                                        <Link to="/option-job-value" className="nav-link" data-key="t-crypto">Option Job Value</Link>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li >
                            <a
                                className={`nav-link menu-link ${selected === 'Metrics' ? 'selected' : ''}`}
                                href="#Metrics"
                                data-bs-toggle="collapse"
                                role="button"
                                aria-expanded="false"
                                aria-controls="Metrics"
                                onClick={() => handleSelect('dashboard4')}
                            >
                                <i className="las la-tachometer-alt"></i> <span data-key="t-dashboards">Metrics</span>
                            </a>
                            <div className="collapse menu-dropdown" id="Metrics">
                                <ul className="nav nav-sm flex-column">

                                    <li >
                                        <Link to="/casting-charges" className="nav-link" data-key="t-analytics">Casting Charges</Link>
                                    </li>

                                    <li >
                                        <Link to="/daily-metal-fix" className="nav-link" data-key="t-crm">Daily Metal Fix</Link>
                                    </li>

                                    <li >
                                        <Link to="/api-metal-price" className="nav-link" data-key="t-crm">API Metal Price</Link>
                                    </li>

                                    <li >
                                        <Link to="/wax-to-metal-conversion" className="nav-link">Wax to Metal Conversion</Link>
                                    </li>

                                </ul>
                            </div>
                        </li>

                        <li >
                            <a
                                className={`nav-link menu-link ${selected === 'Settings' ? 'selected' : ''}`}
                                href="#Settings"
                                data-bs-toggle="collapse"
                                role="button"
                                aria-expanded="false"
                                aria-controls="sidebarDashboards5"
                                onClick={() => handleSelect('Settings')}
                            >
                                <i className="ri-settings-2-line"></i> <span data-key="t-dashboards">Settings</span>
                            </a>
                            <div className="collapse menu-dropdown" id="Settings">
                                <ul className="nav nav-sm flex-column">


                                    <li >
                                        <Link to="/company/list" className="nav-link" data-key="t-analytics">Company</Link>
                                    </li>
                                    <li >
                                        <Link to="/users/list" className="nav-link" data-key="t-crypto">Users</Link>
                                    </li>
                                    <li >
                                        <Link to="/groups" className="nav-link" data-key="t-crypto">Groups</Link>
                                    </li>
                                    {/*  <li >
                                        <Link to="/objects" className="nav-link" data-key="t-crypto">Objects</Link>
                                    </li> */}

                                    <li >
                                        <Link to="/change-password" className="nav-link" data-key="t-analytics">Change Password</Link>
                                    </li>
                                    <li >
                                        <Link to="/metals-price-api" className="nav-link" data-key="t-analytics">Process - Metal Prices API </Link>
                                    </li>
                                    <li >
                                        <Link to="/xero-autenticator" className="nav-link" data-key="t-crypto">Xero Autenticator</Link>
                                    </li>

                                    <li >
                                        <Link to="/profiles" className="nav-link" data-key="t-crm">Profile</Link>
                                    </li>

                                    <li >
                                        <Link to="/docs/pages-starter.html" target='_blank' className="nav-link" data-key="t-crm">Documentation</Link>
                                    </li>

                                </ul>
                            </div>
                        </li>

                        <li >
                            <Link
                                className={`nav-link`}
                                to="/logout"
                                style={{ color: 'white' }}
                                onClick={() => handleSelect('logout')}
                            >
                                <i class="mdi mdi-logout fs-34 align-middle me-1" style={{ color: "red" }}></i>
                                <span data-key="t-layouts">Logout</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Sidebar2;
